import { SparklesIcon } from "@heroicons/react/24/outline";

interface ContextMismatchBannerProps {
  visible: boolean;
  onNavigate: () => void;
  onDismiss: () => void;
}

export function ContextMismatchBanner({
  visible,
  onNavigate,
  onDismiss,
}: ContextMismatchBannerProps) {
  if (!visible) return null;

  return (
    <div className="mb-3">
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 shadow-sm">
        <div className="flex items-start gap-2">
          <SparklesIcon className="h-5 w-5 flex-shrink-0 text-amber-600 mt-0.5" />
          <div className="flex-1 space-y-2">
            <p className="text-sm text-amber-900 leading-relaxed">
              This conversation belongs to a different page.
            </p>
            <div className="flex items-center justify-between">
              <button
                type="button"
                onClick={onDismiss}
                className="text-xs font-medium text-gray-500 hover:text-gray-700 underline">
                Dismiss
              </button>
              <button
                type="button"
                onClick={onNavigate}
                className="inline-flex items-center gap-1 rounded-full bg-amber-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition-colors duration-200 hover:bg-amber-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600">
                <span>Go there</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
